import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-logo',
  templateUrl: './icon-logo.component.html',
  styleUrls: ['./icon-logo.component.scss']
})
export class IconLogoComponent implements OnInit {

  @Input() cssClass = '';

  constructor() { }

  ngOnInit() {
  }

}
